import InitVueApp from '@/entry';
import App from './App';
import { appElement } from '../config';
import store from '../store';
import '@/plugins/vee-validate';
import '@/plugins/google-recaptcha';

new InitVueApp(App, appElement, { store });
